import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import BaseColorPicker from './BaseColorPicker'
import type { BaseColorPickerProps } from './BaseColorPicker'

interface ColorPickerProps extends BaseColorPickerProps {}

const useStyles = makeStyles<Theme, ColorPickerProps>((theme) => ({
  root: {},
  swatch: {
    background: 'none',
    border: 'none',
    width: '100%'
  },
  popover: {
    position: 'absolute',
    zIndex: 2
  },
  cover: {
    position: 'fixed',
    top: theme.typography.pxToRem(0),
    right: theme.typography.pxToRem(0),
    bottom: theme.typography.pxToRem(0),
    left: theme.typography.pxToRem(0)
  },
  colorCard: {
    boxShadow: theme.shadows[1],
    '& .hex': {
      ...theme.typography.body1,
      textTransform: 'uppercase',
      fontWeight: 600,
      padding: theme.spacing(1),
      textAlign: 'start',
      color: theme.paintscout.palette.brand.Neutral.P60
    }
  },
  label: {
    ...theme.typography.overline,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left',
      paddingLeft: theme.spacing(2)
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(1)
    }
  },
  colorStyle: {
    height: '64px',
    cursor: 'pointer'
  }
}))

function ColorPicker(props: ColorPickerProps) {
  const classes = useStyles(props)

  return <BaseColorPicker {...props} classes={classes} />
}

export default ColorPicker
